import React, { useState } from "react";

// MATERIAL UI COMPONENTS
import { StyledTextField } from "../styled/inputs/textInput";

const NameFilter = ({ selectedValue, onFilterChange }) => {
  const [queryString, setQueryString] = useState(null);

  return (
    <StyledTextField
      labelpadding="6px 0"
      size="small"
      id="customer-name"
      name="customer-name"
      label="Nome"
      fullWidth
      variant="outlined"
      value={queryString}
      onChange={(event) => {
        setQueryString(event.target.value);
        onFilterChange(event.target.value);
      }}
    />
  );
};

NameFilter.displayName = "Nome do Cliente";

export default NameFilter;
